import React, {useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Header.css";
import DropdownNav from "../../Header/DropdownNav/DropdownNav";

export default function Header() {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

   useEffect(() => {
    function updateHeaderHeight() {
      const header = document.querySelector(".ijacna-header");
      const height = header ? header.offsetHeight : 0;
      document.documentElement.style.setProperty(
        "--ijacna-header-height",
        height + "px"
      );
    }

    updateHeaderHeight();
    window.addEventListener("resize", updateHeaderHeight);

    return () => window.removeEventListener("resize", updateHeaderHeight);
  }, []);

  return (
    <>
      <header className="ijacna-header">
        {/* 🔹 Topbar Section */}
        <div className="ijacna-topbar">
          <div className="ijacna-logo-section">
            <img
              src="/images/ijacna-logo.png"
              alt="IJACNA Logo"
              className="ijacna-logo"
            />
            <div className="ijacna-title">
              <h1>
                International Journal of Advanced Communication and Network
                Applications (IJACNA)
              </h1>
               <p className="ijacna-subtitle">
                Focus on <span class="highlight-red">Wireless Communication</span>, 
                <span class="highlight-red"> Networking</span> & 
                <span class="highlight-red"> Cybersecurity</span> | CrossRef Indexed Journal
              </p>


              {/* <p>
                ISSN (O) <span className="highlight-red">2320–5407</span>, ISSN
                (P) <span className="highlight-red">3107–4928</span> | A Peer
                Reviewed, CrossRef Indexed Journal
              </p> */}
            </div>
          </div>

          {/* 🔹 Social Icons */}
          <div className="ijacna-social-icons">
            <a href="#" className="ijacna-social facebook">
              <i className="fab fa-facebook-f"></i>
            </a>
            <a href="#" className="ijacna-social linkedin">
              <i className="fab fa-linkedin-in"></i>
            </a>
            <a href="#" className="ijacna-social twitter">
              <i className="fab fa-twitter"></i>
            </a>
            <a href="#" className="ijacna-social instagram">
              <i className="fab fa-instagram"></i>
            </a>
            <a href="#" className="ijacna-social blogger">
              <i className="fab fa-blogger-b"></i>
            </a>
          </div>

          {/* 🔹 Mobile Menu Toggle */}
          <button
            className="ijacna-menu-toggle"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <i className="fas fa-bars"></i>
          </button>
        </div>
      </header>
      {/* 🔹 Sticky Marquee */}
      <div className="ijacna-marquee">
        <marquee behavior="scroll" direction="left">
          📢 Paper Submission Open — Submit your research in Communication, Networking, Cyber Security, Cloud Computing, 5G MIMO, and emerging technologies to IJACNA!
        </marquee>
      </div>


      {/* Pass menu state to dropdown nav */}
      <DropdownNav menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
    </>
  );
}
